import { render, staticRenderFns } from "./editpage.vue?vue&type=template&id=48dbf3d7"
import script from "./editpage.vue?vue&type=script&lang=js"
export * from "./editpage.vue?vue&type=script&lang=js"
import style0 from "./editpage.vue?vue&type=style&index=0&id=48dbf3d7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports